import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getList as _getList, getObj, delObj } from '@/api/visual/map';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import mapDrawer from "./component/mapDrawer.vue";
export default {
  mixins: [JeecgListMixin],
  components: {
    mapDrawer: mapDrawer
  },
  data: function data() {
    return {
      autoLoadInit: false,
      data: [],
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '地图名称',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.getList(1);
  },
  methods: {
    onToAdd: function onToAdd(row, done) {
      this.$refs.modalForm.add();
    },
    handleEdit: function handleEdit(record, state) {
      var _this = this;

      getObj(record.id).then(function (res) {
        var data = res.result;

        _this.$refs.modalForm.edit(data, state);
      });
    },
    handleDelete: function handleDelete(id) {
      var _this2 = this;

      delObj(id).then(function () {
        _this2.$message.success('删除成功');

        _this2.getList();
      });
    },
    modalFormOk: function modalFormOk() {
      this.getList();
    },
    getList: function getList(arg) {
      var _this3 = this;

      _getList(this.getQueryParams()).then(function (res) {
        var data = res.result;
        _this3.ipagination.total = data.total;
        _this3.data = data.records;
      });
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;

        if (sorter.column && sorter.column.colName) {
          this.isorter.column = sorter.column.colName;
        }

        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }

      this.ipagination = pagination;
      this.getList();
    }
  }
};